import { configureStore } from "@reduxjs/toolkit";
import LoginReducer from "./LoginSlice";
import ProfileReducer from "./ProfileSlice";
import CourseReducer from "./CourseSlice";
import MapReducer from "./MapSlice";
import RangeInfoReducer from "./RangeInfoSlice";
import DrivingRangeReducer from "./DrivingRangeSlice"
import HeatMapReducer from "./HeatMapSlice"
import CourseMapReducer from "./CourseMapSlice";
export default configureStore({
  reducer: {
    LoginData: LoginReducer,
    ProfileData: ProfileReducer,
    associatedCourseData: CourseReducer,
    // CourseData: CourseReducer,
    RangeInfo: RangeInfoReducer,
    MapData: MapReducer,
    DrivingRange: DrivingRangeReducer,
    HeatMap:HeatMapReducer,
    CourseMap:CourseMapReducer
  },
});
